<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close">
            <template #body>
                <div class="flex flex-col">
                    <label for="client">
                        {{ $t('client') | capitalize }}
                    </label>
                    <v-select :options="clients" class="w-full custom-select" label="ClientName" :reduce="(item) => item.ClientId" v-model="clientId"></v-select>
                </div>

                 <div class="flex flex-col mt-4">
                    <label for="client">
                        {{ $t('period') | capitalize }} ({{$t('year')}} - {{$t('week')}})
                    </label>
                    <v-select :options="periods" class="w-full custom-select" label="WeekInvoice" :reduce="(item) => item.PeriodId" v-model="periodId"></v-select>
                </div>

                <div class="flex flex-col mt-4">
                    <label for="hours">
                        {{ $t('hours') | capitalize }}
                    </label>
                    <vs-input class="w-full" type="number" v-model="hours"/>
                </div>
                 <div class="flex flex-col mt-4">
                      <vs-checkbox color="success" v-model="checkAddExpenses">{{ $t('add_expenses') | capitalize }}</vs-checkbox>
                </div>
                <div class="flex flex-col mt-4">
                      <upload-file accept="application/pdf" :maxSize="1" @update="handleFiles" />
                </div>

                
                <vs-alert :active="alert" class="mt-4" color="warning">
                    Please enter a valid number of hours.
                </vs-alert>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="save" :disabled="disabled">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'
import vSelect from 'vue-select'
import UploadFile from '@/views/app/components/UploadFile.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    clients: { type:Array, default: () => ([])},
    periods: { type:Array, default: () => ([])}
})

const emit = defineEmits(['click', 'submit'])

const hours = ref(1)
const checkAddExpenses = ref(false)
const clientId = ref('')
const periodId = ref('')
const documents = ref([])

watch(() => props.value, (newValue) => {
    if (newValue) {
        hours.value = 1
        checkAddExpenses.value = false
        clientId.value = ''
        periodId.value = ''
        documents.value = []
    }
})

const alert = computed(() => hours.value <= 0 && hours.value != '')
const disabled = computed(() => 
    clientId.value === '' || clientId.value === null ||
    periodId.value === '' || periodId.value === null ||
    hours.value === '' || alert.value
)

const close = () => {
    emit('input', false)
}

const validateHours = () => {
    if(hours.value <= 0){

    }
    return false
}

const handleFiles = (files) => {
    documents.value = [...files]
}


const save = () => {
    const payload = {
        clientId:clientId.value,
        periodId:periodId.value,
        documents:documents.value,
        hours:hours.value,
        addExpenses:checkAddExpenses.value
    }
    emit('submit',payload)
}

</script>

<style scoped>
::v-deep(.custom-select .vs__dropdown-menu) {
  max-height: 100px;
}
</style>